const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    user: state => state.user,
    errorLogs: state => state.errorLog.logs,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    routes: state => state.permission.routes,
    settings: state => state.settings,
    webSocket: state => state.webSocket,
}
export default getters
